/* Renk Sahnesi — sepet (sections/rs-cart.liquid). Saf JS, bağımlılık yok.

   JS yokken adet ve kaldırma bağlantıları /cart/change adresine gider ve sayfa
   yenilenir. Burada aynı işlem /cart/change.js ile yapılır; yanıtla birlikte
   gelen bölüm HTML'inden yalnız data-rs-cart-part taşıyan bölgeler değiştirilir.
   Ödeme düğmesi ve güven satırları yerinde kalır (oyunperest.js'in kargo geri
   sayımı o satırlara bir kez bağlanır).

   Satırlar sıra numarasıyla değil anahtarla (data-key = item.key) adreslenir:
   öneriden kitap eklenince Shopify yeni satırı başa koyar, ekrandaki liste
   tazelenene kadar sıra numaraları bir kayar; anahtar kaymaz.

   Bir istek sürerken gelen −/+ dokunuşları yutulmaz: satır başına tek bir hedef
   adet olarak bekletilir ve istek bitince gönderilir (bkz. request / flush).

   Sepete ekleme oyunperest.js'tedir (data-op-add); ekleme bitince yayılan
   'op:cart-updated' olayıyla sepet buradan tazelenir. Bu dosya o olayı kendisi
   yaymaz, başlıktaki sayacı doğrudan günceller.

   Çapraz satıştan eklemede yeni satır listeyi aşağı iter; öneri listesi
   parmağın altından kaçmasın diye kaydırma aynı miktarda telafi edilir ve
   klavye odağı aynı sıradaki "+" düğmesine geri verilir.

   Satır kaldırılınca (Kaldır, 1 adette çöp kutusu ya da 0 yazılan adet) "Geri al"
   bildirimi çıkar: varyant, adet ve satır özellikleri (hediye notu dahil) saklanır,
   geri alınca aynı satır yeniden eklenir. Son kitap kaldırıldıysa sayfa boş sepete
   yenilenir; kayıt sessionStorage'da taşınır ve bildirim boş sepette çıkar.

   Sipariş notu (textarea[name=note]) yazıldıkça /cart/update.js ile kaydedilir. */
(function () {
  'use strict';

  var root = document.querySelector('[data-rs-cart]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var errorBox = root.querySelector('[data-rs-cart-error]');
  var addErrorBox = root.querySelector('[data-rs-cart-add-error]');
  var busy = false;
  var leaving = false; /* sayfa yenileniyor ya da başka adrese gidiyor: yeni istek başlatılmaz */
  var pending = []; /* istek sürerken biriken değişiklikler: [{ key, quantity, url }], satır başına tek kayıt */

  function announce(message) {
    if (message && typeof window.opAnnounce === 'function') window.opAnnounce(message);
  }

  function withTimeout(promise) {
    return typeof window.opTimeout === 'function' ? window.opTimeout(promise) : promise;
  }

  function reload() {
    leaving = true;
    window.location.reload();
  }

  /* Sayfayı gerçekten kaydıran öğe: masaüstünde .page-wrapper, dar ekranda pencere */
  function scroller() {
    var wrap = document.querySelector('.page-wrapper');
    if (wrap) {
      var overflow = window.getComputedStyle(wrap).overflowY;
      if ((overflow === 'auto' || overflow === 'scroll') && wrap.scrollHeight > wrap.clientHeight) return wrap;
    }
    return window;
  }

  /* base.css kaydırmayı yumuşatır (scroll-behavior: smooth); telafi anında olmalı */
  function jumpBy(delta) {
    if (!delta) return;
    var target = scroller();
    try {
      target.scrollBy({ top: delta, left: 0, behavior: 'instant' });
    } catch (error) {
      target.scrollBy(0, delta);
    }
  }

  function jumpToTop() {
    var target = scroller();
    try {
      target.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (error) {
      target.scrollTo(0, 0);
    }
  }

  /* Sepet boşken dolunca (ya da tersine) yerleşim baştan değişir. Yenilemeden
     önce başa dönülür ki tarayıcı eski kaydırma konumunu yeni sayfaya taşımasın:
     ziyaretçi sahneyi ve eklediği satırı görsün. */
  function reloadToTop() {
    jumpToTop();
    reload();
  }

  /* Çapraz satış bölümünün ekrandaki üst kenarı (bölüm yoksa ya da gizliyse null) */
  function crossTop() {
    var cross = root.querySelector('.rs-cross');
    return cross && !cross.hidden ? cross.getBoundingClientRect().top : null;
  }

  function lineRows() {
    return root.querySelectorAll('.rs-cart__lines > .rs-line');
  }

  /* Anahtar ":" içerir; seçiciye gömmek yerine nitelik karşılaştırılır */
  function lineRow(key) {
    var match = null;
    if (!key) return match;
    lineRows().forEach(function (row) {
      if (!match && row.getAttribute('data-key') === key) match = row;
    });
    return match;
  }

  /* Alt ödeme çubuğunun arkasında ya da ekran dışında kaldıysa görünür yap */
  function reveal(note) {
    var rect = note.getBoundingClientRect();
    if (rect.top < 0 || rect.bottom > window.innerHeight - 96) note.scrollIntoView({ block: 'center' });
  }

  /* key verilirse mesaj o satır kartının içine yazılır (uzun sepette üstteki
     kutu ekranın dışında kalır); verilmezse ya da satır bulunamazsa üst kutuya.
     Aynı anda yalnız biri dolu olur: mesaj iki kez duyurulmaz. Satır mesajı
     sonraki tazelemede satırlarla birlikte kendiliğinden gider. */
  function showError(message, key) {
    /* Yalnız buradan yazılan not silinir; sunucunun bastığı stok uyarıları (.rs-line__warn) kalır */
    var old = root.querySelector('.rs-line__error');
    if (old) old.remove();

    var row = message && key ? lineRow(key) : null;
    if (row) {
      var note = document.createElement('p');
      note.className = 'rs-line__error';
      note.setAttribute('role', 'alert');
      note.textContent = message;
      row.appendChild(note);
      message = '';
      reveal(note);
    }

    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  /* Başlıktaki sepet sayacı: oyunperest.js'teki refreshCartCount ile aynı davranış */
  function updateCount(count) {
    if (count === null || count === undefined || count === '') return;
    document.querySelectorAll('[data-op-cart-count]').forEach(function (el) {
      var changed = el.textContent !== String(count);
      el.textContent = String(count);
      if (changed) {
        el.classList.remove('op-bump');
        void el.offsetWidth; /* animasyonu yeniden tetikle */
        el.classList.add('op-bump');
      }
    });
  }

  function parse(html) {
    if (!html) return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rs-cart]');
  }

  function findByFocusKey(key) {
    var match = null;
    root.querySelectorAll('[data-rs-focus]').forEach(function (el) {
      if (!match && el.getAttribute('data-rs-focus') === key) match = el;
    });
    return match;
  }

  /* Odaklı satır artık yoksa (kaldırıldı): aynı sıraya gelen satırda aynı tür
     denetim (−, adet, +, kaldır), o yoksa "Kaldır" bağlantısı. Klavye kullanıcısı
     listedeki yerini kaybetmez. */
  function neighbourControl(index, focusKey) {
    var rows = lineRows();
    if (index < 0 || !rows.length) return null;
    var row = rows[Math.min(index, rows.length - 1)];
    var kind = focusKey ? /^[a-z]+-/.exec(focusKey) : null;
    return (kind && row.querySelector('[data-rs-focus^="' + kind[0] + '"]')) || row.querySelector('.rs-line__remove');
  }

  /* Yeni HTML'i yerleştirir. Sepet boşaldıysa, dolduysa ya da bölgeler
     eşleşmiyorsa sayfa yenilenir: en güvenli ortak payda.
     added: çapraz satıştan ekleme sonrası tazelemede { index: düğme sırası };
     o zaman liste yerinde tutulur ve odak geri verilir. */
  function apply(next, added) {
    if (!next) {
      reload();
      return false;
    }
    if (next.getAttribute('data-rs-cart') !== root.getAttribute('data-rs-cart')) {
      reloadToTop();
      return false;
    }

    var current = root.querySelectorAll('[data-rs-cart-part]');
    var incoming = next.querySelectorAll('[data-rs-cart-part]');
    if (current.length !== incoming.length) {
      reload();
      return false;
    }

    var pairs = [];
    for (var i = 0; i < current.length; i += 1) {
      var name = current[i].getAttribute('data-rs-cart-part');
      var fresh = next.querySelector('[data-rs-cart-part="' + name + '"]');
      if (!fresh) {
        reload();
        return false;
      }
      pairs.push([current[i], fresh]);
    }

    var active = document.activeElement;
    var hadFocus = active instanceof Element && root.contains(active);
    var focusKey = hadFocus ? active.getAttribute('data-rs-focus') : null;
    var focusLine = hadFocus ? active.closest('.rs-line') : null;
    var focusIndex = focusLine ? Array.prototype.indexOf.call(lineRows(), focusLine) : -1;

    /* Değişimden hemen önce ölçülür: istek sürerken ziyaretçi kaydırmış olabilir */
    var topBefore = added ? crossTop() : null;

    pairs.forEach(function (pair) {
      pair[0].replaceWith(document.importNode(pair[1], true));
    });

    /* Yeni satır öneri listesini aşağı itti: kaydırmayı aynı kadar ilerlet ki
       liste parmağın altında kalsın */
    if (topBefore !== null) {
      var topAfter = crossTop();
      if (topAfter !== null) jumpBy(Math.round(topAfter - topBefore));
    }

    var count = next.getAttribute('data-item-count');
    root.setAttribute('data-item-count', count || '');
    updateCount(count);

    /* Odak değişen bölgedeydiyse aynı denetime; satır kaldırıldıysa yerine gelen
       satıra; hiç satır kalmadıysa başlığa döner */
    if (hadFocus && !root.contains(document.activeElement)) {
      var target =
        (focusKey && findByFocusKey(focusKey)) ||
        neighbourControl(focusIndex, focusKey) ||
        root.querySelector('#rs-cart-title');
      if (target) target.focus({ preventScroll: true });
    } else if (added && (!document.activeElement || document.activeElement === document.body)) {
      /* Ekleme düğmesi devre dışı kalınca odak gövdeye düşmüştü: aynı sıradaki
         "+" düğmesine, öneri kalmadıysa başlığa döner. Ziyaretçi bu arada başka
         bir yere geçtiyse dokunulmaz. */
      var adds = root.querySelectorAll('.rs-cross:not([hidden]) .rs-add');
      var back = adds.length
        ? adds[Math.min(Math.max(added.index, 0), adds.length - 1)]
        : root.querySelector('#rs-cart-title');
      if (back) back.focus({ preventScroll: true });
    }
    return true;
  }

  function refresh(added) {
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return withTimeout(fetch(url, { headers: { Accept: 'text/html' } }))
      .then(function (response) {
        if (!response.ok) throw new Error('section-failed');
        return response.text();
      })
      .then(function (html) {
        return apply(parse(html), added);
      })
      .catch(function () {
        reload();
      });
  }

  function setBusy(state) {
    busy = state;
    root.classList.toggle('is-busy', state);
    if (state) root.setAttribute('aria-busy', 'true');
    else root.removeAttribute('aria-busy');
  }

  /* İstek bitti: kilidi aç, bekleyen değişiklik varsa sıradakini gönder */
  function release() {
    setBusy(false);
    /* Başka bir istek sürerken basılan "Geri al" sıradadır: önce o çalışır */
    if (undoQueued) {
      var queued = undoQueued;
      undoQueued = null;
      queued.button.disabled = false;
      undoRemove(queued.button, queued.entry);
      return;
    }
    flush();
  }

  /* JS'siz yolla aynı adres (routes.cart_change_url?id=…&quantity=…) */
  function changeUrl(key, quantity) {
    return base + 'cart/change?id=' + encodeURIComponent(key) + '&quantity=' + quantity;
  }

  /* key: satır anahtarı (item.key), quantity: yeni adet (0 = kaldır).
     Doğrudan çağrılmaz; request() kilidi gözetir. */
  function change(key, quantity, fallbackUrl) {
    if (busy || leaving) return;
    setBusy(true);

    /* Kaldırma: geri alma kaydı istekten önce alınır (satır yanıtla birlikte gider).
       Sayfa yenilenirse (son kitap gitti) kayıt sessionStorage'dan okunur. */
    var removed = null;
    if (quantity === 0) {
      var removedRow = lineRow(key);
      var removedInput = removedRow ? removedRow.querySelector('[data-rs-cart-qty]') : null;
      removed = snapshot(removedRow, removedInput ? parseInt(removedInput.defaultValue, 10) : 0);
      store(removed);
    }
    var keepQueued = function () {
      /* Bu istek sürerken "Geri al"a basıldıysa ve istek sepeti boşaltıp sayfayı yenilerse,
         sıradaki geri alma kaybolmasın: kayıt "kendiliğinden geri al" işaretiyle saklanır,
         yeni sayfa açılınca çalıştırılır */
      if (undoQueued) store(Object.assign({}, undoQueued.entry, { auto: true, at: Date.now() }));
    };
    if (quantity !== 0 && !undoQueued) hideUndo();

    withTimeout(
      fetch(base + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: key,
          quantity: quantity,
          sections: [sectionId],
          sections_url: window.location.pathname,
        }),
      })
    )
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          store(null);
          /* Stok sınırı gibi durumlar: mağazanın kendi açıklaması gösterilir,
             satırlar gerçek duruma döner. Bekleyen dokunuşlar artık yanlış bir
             adede dayanıyor olabilir; bırakılır. */
          pending = [];
          var message = result.data.description || result.data.message || root.getAttribute('data-error-text');
          return refresh().then(function (done) {
            if (done) showError(message, key);
          });
        }

        var html = result.data.sections ? result.data.sections[sectionId] : null;
        var after = function (done) {
          if (!done) return;
          store(null);
          showError('');
          if (removed) {
            showUndo(removed);
            var undoText = undoBoxes()[0];
            announce(undoText && !undoText.hidden ? undoText.textContent.replace(/\s+/g, ' ').trim() : root.getAttribute('data-updated-text'));
          } else {
            announce(root.getAttribute('data-updated-text'));
          }
        };
        keepQueued();
        if (!html) return refresh().then(after);
        after(apply(parse(html)));
        return null;
      })
      .catch(function () {
        /* Ağ hatası ya da zaman aşımı: JS'siz yola düş */
        store(null);
        leaving = true;
        if (fallbackUrl) window.location.href = fallbackUrl;
        else window.location.reload();
      })
      .then(release);
  }

  /* Değişiklik isteği: boştaysa hemen gider; bir istek sürüyorsa satırın son
     hedef adedi saklanır (aynı satıra yeni dokunuş öncekinin yerini alır). */
  function request(key, quantity, fallbackUrl) {
    if (leaving) return;
    if (!busy) {
      change(key, quantity, fallbackUrl);
      return;
    }
    for (var i = 0; i < pending.length; i += 1) {
      if (pending[i].key === key) {
        pending[i].quantity = quantity;
        pending[i].url = fallbackUrl;
        return;
      }
    }
    pending.push({ key: key, quantity: quantity, url: fallbackUrl });
  }

  /* Bekleyenleri sırayla gönderir (change kilidi alır; döngü ilk gönderimde
     durur, kalanlar o istek bitince sürer). Satır bu arada sepetten çıktıysa ya
     da zaten o adetteyse kayıt atlanır. */
  function flush() {
    while (pending.length && !busy && !leaving) {
      var next = pending.shift();
      var row = lineRow(next.key);
      if (!row) continue;
      var input = row.querySelector('[data-rs-cart-qty]');
      if (input && String(next.quantity) === input.defaultValue) continue;
      /* Tazelenen kutu sunucudaki adedi gösteriyor; hedefi yeniden yaz */
      if (input && next.quantity > 0) input.value = String(next.quantity);
      change(next.key, next.quantity, next.url);
    }
  }

  /* ---- Kaldırılan satırı geri alma ---- */
  var UNDO_KEY = 'rs-cart-undo';
  var undoBoxes = function () {
    return root.querySelectorAll('[data-rs-cart-undo]');
  };
  var lastRemoved = null;

  function store(entry) {
    try {
      if (entry) window.sessionStorage.setItem(UNDO_KEY, JSON.stringify(entry));
      else window.sessionStorage.removeItem(UNDO_KEY);
    } catch (error) {
      /* gizli pencere: yalnız bellekte tutulur */
    }
  }

  function readStored() {
    try {
      var raw = window.sessionStorage.getItem(UNDO_KEY);
      window.sessionStorage.removeItem(UNDO_KEY);
      var entry = raw ? JSON.parse(raw) : null;
      /* Bir dakikadan eski kayıt (başka sekme, eski ziyaret) gösterilmez */
      return entry && Date.now() - entry.at < 60000 ? entry : null;
    } catch (error) {
      return null;
    }
  }

  /* Satırdan geri ekleme için gereken her şey: varyant, adet, özellikler */
  function snapshot(row, quantity) {
    if (!row) return null;
    var id = Number(row.getAttribute('data-variant-id'));
    if (!id || !quantity) return null;
    var props = null;
    try {
      props = JSON.parse(row.getAttribute('data-props') || 'null');
    } catch (error) {
      props = null;
    }
    return { id: id, quantity: quantity, properties: props, title: row.getAttribute('data-title') || '', at: Date.now() };
  }

  function hideUndo() {
    lastRemoved = null;
    undoBoxes().forEach(function (box) {
      box.hidden = true;
      box.textContent = '';
    });
  }

  function showUndo(entry) {
    var box = undoBoxes()[0];
    if (!box || !entry) return;
    lastRemoved = entry;
    var template = root.getAttribute('data-undo-text') || '[kitap] sepetten çıkarıldı.';
    var text = document.createElement('span');
    var parts = template.split('[kitap]');
    text.appendChild(document.createTextNode(parts[0]));
    if (parts.length > 1) {
      text.appendChild(document.createElement('b')).textContent = entry.title;
      text.appendChild(document.createTextNode(parts.slice(1).join('[kitap]')));
    }
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rs-cart__undo-btn';
    button.setAttribute('data-rs-cart-undo-btn', '');
    button.textContent = root.getAttribute('data-undo-action') || 'Geri al';
    box.textContent = '';
    box.appendChild(text);
    box.appendChild(button);
    box.hidden = false;
  }

  var undoQueued = null;
  function undoRemove(button, queuedEntry) {
    /* Sıraya alınan dokunuş, basıldığı andaki kaydı geri getirir (arada başka bir kitap
       kaldırılmış olsa bile) */
    var entry = queuedEntry || lastRemoved;
    if (!entry || leaving) return;
    /* Başka bir sepet isteği sürüyorsa dokunuş kaybolmaz: sıraya alınır, istek bitince çalışır */
    if (busy) {
      undoQueued = { button: button, entry: entry };
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      return;
    }
    button.removeAttribute('aria-busy');
    button.disabled = true;
    var settle = typeof window.opBusy === 'function' ? window.opBusy(button) : function () {};
    var item = { id: entry.id, quantity: entry.quantity };
    /* Liquid boş özellikleri [] diye yazar; Shopify yalnız nesne kabul eder */
    var props = entry.properties;
    if (props && typeof props === 'object' && !Array.isArray(props) && Object.keys(props).length) item.properties = props;
    setBusy(true);
    withTimeout(
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
    )
      .then(function (response) {
        return typeof window.opAddResponse === 'function' ? window.opAddResponse(response) : response.json();
      })
      .then(function () {
        settle();
        hideUndo();
        announce(root.getAttribute('data-undo-done'));
        /* Boş sepetten dönülüyorsa yerleşim değişir: apply sayfayı yeniler */
        return refresh();
      })
      .catch(function (error) {
        settle();
        button.disabled = false;
        if (typeof window.opRelease === 'function') window.opRelease(button);
        var message = (error && error.reason) || root.getAttribute('data-add-error-text') || root.getAttribute('data-error-text');
        showError(message);
        announce(message);
      })
      .then(release);
  }

  root.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-rs-cart-undo-btn]') : null;
    if (button) undoRemove(button);
  });

  /* Son kitap kaldırılıp boş sepete yenilendiyse ya da sayfa başka nedenle
     yenilendiyse bildirim burada yeniden kurulur — kitap hâlâ sepetteyse kurulmaz */
  (function () {
    var entry = readStored();
    if (!entry) return;
    var stillThere = false;
    if (entry.auto) {
      /* Önceki sayfada sıraya alınan "Geri al" (sayfa yenilendiği için yarım kaldı) */
      delete entry.auto;
      lastRemoved = entry;
      showUndo(entry);
      var btn = root.querySelector('[data-rs-cart-undo-btn]');
      if (btn) undoRemove(btn, entry);
      return;
    }
    lineRows().forEach(function (row) {
      if (Number(row.getAttribute('data-variant-id')) === entry.id) stillThere = true;
    });
    if (!stillThere) showUndo(entry);
  })();

  /* ---- Öneri "+" düğmesi başarısız olursa görünür açıklama ----
     Ekleme oyunperest.js'tedir; hata halinde yalnız düğme metnini data-op-error
     değerine ("!") çevirir ve ekran okuyucuya duyurur. Gören ziyaretçi için
     açıklama burada, dokunulan düğmenin yanına yazılır (duyuru zaten yapıldığı
     için role="alert" taşımaz). Sonraki ekleme denemesinde ya da tazelemede gider. */
  function clearAddError() {
    root.querySelectorAll('.rs-cross__error').forEach(function (el) {
      el.remove();
    });
    if (addErrorBox) {
      addErrorBox.textContent = '';
      addErrorBox.hidden = true;
    }
  }

  function showAddError(button) {
    var reason = addReason && addReason.button === button ? addReason.text : '';
    var message = reason || root.getAttribute('data-add-error-text') || root.getAttribute('data-error-text');
    if (!message || !root.contains(button)) return;
    clearAddError();

    var note = null;
    var row = button.closest('.rs-cross__row');
    if (row) {
      note = document.createElement('p');
      note.className = 'rs-cross__error';
      note.textContent = message;
      row.appendChild(note);
    } else if (addErrorBox) {
      addErrorBox.textContent = message;
      addErrorBox.hidden = false;
      note = addErrorBox;
    }
    if (note) reveal(note);
  }

  /* oyunperest.js ekleme başarısız olunca belgeye 'op:cart-error' yayar
     (detail: { message, reason, status, button }). reason, Shopify'ın kendi cümlesidir
     ("Sepetinizde zaten bu üründen maksimum miktarda bulunuyor."); varsa genel cümlenin
     yerine o yazılır. preventDefault: açıklama burada, düğmenin yanında gösterildiği için
     renk-sahnesi.js alttaki bildirimi ayrıca çıkarmaz. Hatanın tek kaynağı bu olaydır. */
  var addReason = null;
  document.addEventListener('op:cart-error', function (event) {
    var detail = event.detail || {};
    if (!detail.button || !root.contains(detail.button)) return;
    event.preventDefault();
    addReason = { button: detail.button, text: detail.reason || '' };
    showAddError(detail.button);
  });

  if (sectionId) {
    /* Adet −/+ ve kaldır bağlantıları */
    root.addEventListener('click', function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target instanceof Element ? event.target.closest('[data-rs-cart-change]') : null;
      if (!link) return;
      /* Stok sınırındaki "+" (aria-disabled, adresi yok) hiçbir şey yapmaz */
      if (link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }

      var key = link.getAttribute('data-key');
      if (!key) return;

      /* −/+ : hedef, kutuda o an yazan adetten hesaplanır (data-qty sunucunun
         bastığı mutlak değerdir; art arda dokunuşta eskir). Kaldır: data-qty = 0. */
      var step = Number(link.getAttribute('data-step')) || 0;
      var row = link.closest('.rs-line');
      var input = step && row ? row.querySelector('[data-rs-cart-qty]') : null;
      var quantity = Number(link.getAttribute('data-qty'));
      if (input) {
        var shown = parseInt(input.value, 10);
        if (isNaN(shown) || shown < 0) shown = parseInt(input.defaultValue, 10);
        if (!isNaN(shown)) quantity = shown + step;
      }
      if (isNaN(quantity)) return;

      event.preventDefault();
      if (quantity < 0) return;

      /* Yeni adet hemen görünür; satır tutarı yanıtla birlikte güncellenir */
      if (input && quantity > 0) input.value = String(quantity);
      request(key, quantity, changeUrl(key, quantity));
    });

    /* Elle yazılan adet */
    root.addEventListener('change', function (event) {
      var input = event.target instanceof Element ? event.target.closest('[data-rs-cart-qty]') : null;
      if (!input) return;

      var key = input.getAttribute('data-key');
      var quantity = parseInt(input.value, 10);
      if (!key || isNaN(quantity) || quantity < 0) {
        input.value = input.defaultValue;
        return;
      }
      /* İstek sürerken sunucudaki adet değişiyor olabilir: karşılaştırma flush'ta yapılır */
      if (!busy && String(quantity) === input.defaultValue) return;
      request(key, quantity, null);
    });

    /* Adet kutusunda Enter formu (dolayısıyla ödemeyi) göndermesin; adedi uygulasın */
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target instanceof Element ? event.target.closest('[data-rs-cart-qty]') : null;
      if (!input) return;
      event.preventDefault();
      /* Odak kutuda kalır; tazelemeden sonra aynı kutuya geri verilir */
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    /* Çapraz satıştaki "+" düğmesine basıldı: sırası saklanır (ekleme
       oyunperest.js'tedir; düğmeyi devre dışı bıraktığı için odak düşer).
       Boş sepetteki kart düğmeleri de buradan izlenir (hata açıklaması için). */
    var crossAdd = null;
    root.addEventListener('click', function (event) {
      var button = event.target instanceof Element ? event.target.closest('[data-op-add]') : null;
      if (!button) return;
      var cross = button.closest('.rs-cross');
      crossAdd = cross
        ? { index: Array.prototype.indexOf.call(cross.querySelectorAll('.rs-add'), button) }
        : null;
      clearAddError();
    });

    /* Çapraz satıştan ya da boş sepetteki kartlardan ekleme: "✓" kısa bir an
       görünsün, sonra sepet tazelensin */
    var refreshTimer = null;
    function refreshAfterAdd() {
      if (leaving) return;
      if (busy) {
        /* Başka bir işlem sürüyor: bu tazelemeyi kaçırma, biraz sonra dene */
        refreshTimer = setTimeout(refreshAfterAdd, 200);
        return;
      }
      var added = crossAdd;
      crossAdd = null;
      setBusy(true);
      refresh(added).then(release);
    }
    document.addEventListener('op:cart-updated', function () {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(refreshAfterAdd, 350);
    });

    /* Geri tuşuyla önbellekten dönüldüyse sepet eski kalmış olabilir */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      leaving = false;
      if (busy) return;
      /* Diğer tazelemeler gibi kilitle: dönüş anındaki −/+ dokunuşu bekletilir, yarışmaz */
      setBusy(true);
      refresh().then(release);
    });
  }

  /* Ödemeye geçerken düğme bekleme diline geçer (çift tıklama önlenir) */
  var form = document.getElementById('rs-cart-form');
  if (form) {
    form.addEventListener('submit', function (event) {
      var button = event.submitter;
      if (button && button.getAttribute('name') === 'checkout' && typeof window.opBusy === 'function') {
        window.opBusy(button);
      }
    });
  }

  /* Alt ödeme çubuğu: özet kartının üst kenarı çubuğun üst kenarına ulaşınca (ya
     da kart geçildiyse) çekilir. Çapa kartın kendisidir, içindeki düğme değil:
     çubuk en fazla kartın başlık payını örter, aynı tutarı yineleyerek büyük
     toplamın üstüne binmez; karta taksit notu ya da indirim satırı eklense de
     hesap değişmez. Kart data-rs-cart-part değildir; tazelemede yerinde kalır.
     84px = çubuğun yüksekliği (10 + 64 + 10). Dar ekranda kaydıran penceredir. */
  var bar = root.querySelector('[data-rs-cart-bar]');
  var anchor = root.querySelector('.rs-sum');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-off', entry.isIntersecting || entry.boundingClientRect.top < 0);
        });
      },
      { rootMargin: '0px 0px -84px 0px' }
    ).observe(anchor);
  }

  /* ---- Sipariş notu: yazıldıkça kaydedilir ----
     Ödeme düğmesine basılınca not zaten formla gider (form="rs-cart-form"); bu
     kayıt yalnız ziyaretçi başka sayfaya geçip dönerse notun kaybolmaması için. */
  var note = root.querySelector('[data-rs-cart-note]');
  if (note) {
    var noteStatus = root.querySelector('[data-rs-cart-note-status]');
    var noteTimer = null;
    var noteSaved = note.value;
    var saveNote = function () {
      clearTimeout(noteTimer);
      var value = note.value;
      if (value === noteSaved) return;
      fetch(base + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: value }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('note-failed');
          noteSaved = value;
          if (noteStatus) noteStatus.textContent = root.getAttribute('data-note-saved') || '';
        })
        .catch(function () {
          /* sessiz: ödemeye geçerken not formla yine gider */
        });
    };
    note.addEventListener('input', function () {
      if (noteStatus) noteStatus.textContent = '';
      clearTimeout(noteTimer);
      noteTimer = setTimeout(saveNote, 800);
    });
    note.addEventListener('change', saveNote);
    /* Sayfadan çıkarken bekleyen kayıt (pagehide bfcache'i bozmaz) */
    window.addEventListener('pagehide', function () {
      if (note.value === noteSaved) return;
      try {
        navigator.sendBeacon(base + 'cart/update.js', new Blob([JSON.stringify({ note: note.value })], { type: 'application/json' }));
      } catch (error) {
        /* desteklenmiyorsa geç */
      }
    });
  }
})();
